module.exports = " <div class=\"select select-full\" data-content=\"{{ selected | capitalize }}\"> <span class=\"status status-{{ selected }}\"></span> <select name=status v-model=selected options=options></select> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/StatusFieldtype.vue
// module id = 742
// module chunks = 0